import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2.38rem 2.38rem;

  @media (max-width: 1024px) {
    padding: 0 1.38rem;
  }
`;

export const MainContent = styled.div`
  width: calc(100% - var(--videobar-width));
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 0 0;

  > .primary-button {
    width: 13rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #fff;

    padding: 0.77rem 1rem;
    border-radius: 0.55rem;
    min-width: 10.57rem;
    min-height: 2.82rem;
    box-shadow: 0px 3px 6px rgba(255, 159, 0, 0.3);

    > svg {
      margin-right: 0.88rem;
    }
  }
`;

export const TitleWrapper = styled.header`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.88rem;
  }

  h1 {
    text-align: center;
    font-family: 'RedHatDisplay-Extrabold';
    color: #1e88e5;
    font-size: 2rem;
    line-height: 2.55rem;
    margin-right: 0.88rem;
  }

  > div > svg {
    display: block;
    margin: auto;
    position: relative;
    cursor: pointer;
    transition: stroke 0.3s;
  }

  > div > svg {
    stroke: ${lighten(0.16, '#63646A')};

    &:hover {
      stroke: #63646a;
    }
  }

  p {
    font-family: 'MarkPro';
    font-size: 1rem;
    line-height: 1.44rem;
    margin-left: 1.88rem;
  }
`;

export const WrapperMainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const NavigationMenu = styled.div`
  padding-top: 3vh;

  @media (max-width: 1024px) {
    padding-top: 1vh;
  }

  .profile-navBar {
    width: 98%;
    background: none;
    border: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
    margin-bottom: 6.11vh;

    @media (max-width: 1024px) {
      margin-bottom: 3.11vh;
    }
  }

  .profile-tabs-container {
    overflow: visible !important;
  }

  .MuiTabs-scroller.MuiTabs-fixed {
    overflow: visible !important;
  }

  .profile-tab-item {
    margin-right: 3.22rem;
    > span {
      font-family: 'RedHatDisplay-Regular';
      font-size: 1.22rem;
      color: #000 !important;
      text-transform: none;
    }

    &:hover {
      color: #000 !important;
      opacity: 1;
    }
  }
`;

export const RightSideContent = styled.div`
  width: var(--videobar-width);
  max-width: var(--videobar-width);
  border-left: 0.5px solid rgba(0, 0, 0, 0.1);
  min-height: 100vh;
  overflow: hidden;

  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 0 1rem;
  box-sizing: border-box;

  > h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.6rem;
    line-height: 2.44rem;
    text-align: center;
  }
`;

export const ChallengeCardsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;
